var PolicyService = /** @class */ (function () {
    function PolicyService(api) {
        this.API = api;
    }
    PolicyService.prototype.policyLatest = function () {
        var url = '/policy/latest';
        return this.API.get(url);
    };
    PolicyService.prototype.policyLatestAccept = function (policyId) {
        var url = '/policy/latest/accept';
        var formData = {
            policy_id: policyId,
        };
        return this.API.post(url, formData);
    };
    PolicyService.prototype.policyAll = function () {
        var url = '/policy/all';
        return this.API.get(url);
    };
    return PolicyService;
}());
export { PolicyService };
